<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
        <button (click)="save()" [disabled]="this.editedFields.length==0" analyticsAction="Save"
                analyticsCategory="Save"
                class="start-data-survey"
                mat-button
                particleAnalytics>
          <i class="fas fa-check"></i> Save Changes ({{this.editedFields?.length}})
        </button>
      </div>
    </div>
  </div>


  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg" helpNoteId="dac6-pre-arrangement-details" particleHelpNotes>
        <!-- CONTENT TOOLBAR -->

        <div *ngIf="item" class="content  pos-relative flex flex-col full-grow-no-shrink-no-basis">
          <particle-dynamic-form-container (selectedSectionHearderKey)="selectedSectionIndexChange($event)"
                                           (fieldSelectionChange)="onSelectionFieldChanged($event)"
                                           (valueChanged)="onValueChanged($event)"
                                           [editedFields]="editedFields"
                                           [endpointName]="endpointName"
                                           [fieldConfig]="fieldConfig"
                                           [formField]="formField"
                                           [invalidateSubject]="invalidateSubject"
                                           [invalidateSubject]="invalidateSubject"
                                           [item]="item"
                                           [showLanguageOption]="showLanguageOption"
                                           [showOriginal]="showOriginal"
                                           [sourceType]="sourceType"
                                           class="particle-dynamic-form-container"
          >
          </particle-dynamic-form-container>

        </div>


      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
